import React, { useState, useEffect } from 'react';
import { Button, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import * as Actions from './actions/PhotoOrderListActions';
import * as ProductProperty from '../../shared/ProductProperties';
import DesktopOrderTable from './DesktopOrderTable';
import MobileOrderTable from './MobileOrderTable';

interface IEditedPhotoOrdersListActions {
    getEditedPhotoOrders: () => any;
}

interface IEditedPhotoOrdersListProps {
    actions: IEditedPhotoOrdersListActions;
    orders: any[];
    router: any;
    user: any;
}

const productsToExclude = [ProductProperty.BlueSky, ProductProperty.InteriorBlueSky];

function useMediaQuery(query: string) {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);
        const updateMatch = () => setMatches(media.matches);

        updateMatch();
        media.addEventListener('change', updateMatch);

        return () => media.removeEventListener('change', updateMatch);
    }, [query]);

    return matches;
}

const EditedPhotoOrderList: React.FC<IEditedPhotoOrdersListProps> = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<any>({});
    const isDesktop = useMediaQuery('(min-width: 992px)');

    useEffect(() => {
        props.actions.getEditedPhotoOrders();
    }, [props.actions]);

    const openModal = (order: any) => {
        setSelectedOrder(order);
        setShowModal(true);
    };

    const userRole = props.user.details.role;

    return (
        <div>
            {showModal && (
                <Modal
                    bsSize="sm"
                    show={showModal && selectedOrder}
                    onHide={() => setShowModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{Translate('edited-orders/modal/title')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedOrder.photographerInstruction.map((x: any, index: number) => (
                            <div key={index}>
                                <h4>{x.productName}</h4>
                                <span>{x.instructions}</span>
                                {index + 1 !== selectedOrder.photographerInstruction.length && <hr />}
                            </div>
                        ))}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setShowModal(false)}>
                            {Translate('edited-orders/modal/button/close')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <Row>
                {isDesktop ? (
                    <DesktopOrderTable
                        orders={props.orders}
                        userRole={userRole}
                        productsToExclude={productsToExclude}
                        openModal={openModal}
                    />
                ) : (
                    <MobileOrderTable
                        orders={props.orders}
                        userRole={userRole}
                        productsToExclude={productsToExclude}
                        openModal={openModal}
                    />
                )}
            </Row>
        </div>
    );
};

function mapStateToProps(state: any) {
    return {
        orders: state.photoOrderLists.orders
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getEditedPhotoOrders: () => dispatch(Actions.getEditedPhotoOrders())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditedPhotoOrderList);